<template lang="pug">

.busy(v-if='creating || loading')
  b-spinner

b-container(v-else fluid)
  b-row
    b-col(cols=12)
      b-card(header='Smart link')
        table.table.table-bordered
          tr
            td(rowspan="3" class="text-center" width="300")
              img.mb-3(
                :src="smartlink.image" width="100%" 
              )

              router-link(
                :to="{ name: 'release-detail', params: { id: smartlink.AlbumID } }"
              ) Terug naar album
              br
              a.mb-5(
                :href="smartlink.domain + '/' + smartlink.shortId" 
                target="_blank"
              ) Bekijk smartlink pagina
              
              p.mt-3.mb-0 {{ smartlink.domain + '/' + smartlink.shortId }}

              b-button.mt-4(@click="update", v-if="$root.$data.me.Type == 'admin'") Update

            th {{ $t('Artist') }}
            td {{ smartlink.artist.name }}

            th {{ $t('Title') }}
            td {{ smartlink.title }}

          tr(v-if='false')
            th {{ $t('Description') }}
            td {{ smartlink.description }}
            
            th {{ $t('Pre release description') }}
            td {{ smartlink.preReleaseDescription }}

          tr
            th {{ $t('Stores') }}
            td 
              ul(v-if="smartlink.enabledStores")
                li(v-for='store in smartlink.enabledStores') {{ store.storeId }}
              span(v-else) Scanning...

            // th {{ $t('Social') }}
            // td {{ smartlink.socialIcons }}
            td
            th

        b-form.mt-5(v-if='false')
          form-field(v-for="field, name in form.fields" :name="name" :key="name")

          b-alert(
            :show="form.errorMsg !== ''" 
            variant="danger"
          ) {{ form.errorMsg }}

          b-button(@click="save" :disabled='disabledSave') Save

        pre.mt-5(v-if="$root.$data.me.Type == 'admin'") {{ smartlink }}



</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        creating: false,
        loading: true,
        disabledSave: false,
        smartlink: null,
        form: {
          values: {},
          errorMsg: '',
          model: this.smartlink,
          fields: {
            description: {
              type: 'text',
              required: true,
            },
            socialIcons: {
              type: 'boolean',
            },

          }
        }
      }
    },
    provide () {
      return {
        'model': () => this.smartlink,
        'form': this.form,
        'formUpdate': this.updateForm,
      }
    },
    props: {
      id: String,
      create: {
        type: Boolean,
        value: false,
      },
      holder: {
        type: Object,
        default: null,
      },
    },
    watch: {
      async id () {
        if (this.smartlink?.id == this.id) return

        this.smartlink = null
        
        this.fetchLink()
      }
    },
    methods: {
      async update () {
        this.creating = true
        const response = await this.$http.put(
          'albums/' + this.smartlink.AlbumID + '/smart-links/' + this.id, 
          { }
        )
        this.smartlink = response.data
        this.creating = false
      },
      updateForm(field, value) {
        this.$set(this.form.values, field, value)
      },
      async createLink () {
        if (!this.holder) {
          this.$notify({
            type: 'warn',
            text: this.$t('No album data available'),
          })
          return
        }

        try {
          this.creating = true
          const response = await this.$http.post(
            'albums/' + this.holder.AlbumID + '/smart-links', 
            { }
          )

          this.smartlink = response.data

          this.$router.replace({ 
            params: {
              ...this.$route.params,
              'id': this.smartlink.id,
              'create': false
            }
          }) 
        } catch (error) {
          this.$notify({
            type: 'warn',
            text: this.$t('Something went wrong while creating smart-link, please try again.'),
          })
          throw error
        } finally {
          this.creating = false
          this.loading = false
        }
      },
      async fetchLink () {
        try {
          this.loading = true

          const response = await this.$http.get(
            `smart-links/${this.id}`
          )

          this.smartlink = response.data
        } catch (error) {
          this.$notify({
            type: 'warn',
            text: this.$t('Something went wrong while loading smart-link, please try again.'),
          })

          throw error
        } finally {
          this.loading = false
        }

      },
      async save () {

      },
    },
    async mounted () {
      if (this.create) {
        this.createLink()
      } else {
        this.fetchLink()
      }
    }
  }
</script>